import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Button,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import { Add as AddIcon, Visibility, Edit } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHotels } from '../../store/slices/hotelSlice';
import locationService from '../../services/api/locationService';

const HotelsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hotels, loading } = useSelector((state) => state.hotels);
  const [searchTerm, setSearchTerm] = useState('');
  const [cityFilter, setCityFilter] = useState('');
  const [cities, setCities] = useState([]);

  useEffect(() => {
    dispatch(fetchHotels({ search: searchTerm, cityId: cityFilter }));
    fetchCities();
  }, [dispatch, searchTerm, cityFilter]);

  const fetchCities = async () => {
    try {
      const data = await locationService.getAllCities();
      setCities(data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Hotels
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/hotels/new')}
        >
          Add Hotel
        </Button>
      </Box>

      {/* Filters */}
      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Search Hotels"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel>City</InputLabel>
              <Select
                value={cityFilter}
                onChange={(e) => setCityFilter(e.target.value)}
                label="City"
              >
                <MenuItem value="">All Cities</MenuItem>
                {cities.map((city) => (
                  <MenuItem key={city.id} value={city.id}>
                    {city.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>City</TableCell>
                <TableCell>Area</TableCell>
                <TableCell>Star Rating</TableCell>
                <TableCell>Distance from Haram</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {hotels.map((hotel) => (
                <TableRow key={hotel.id}>
                  <TableCell>{hotel.name}</TableCell>
                  <TableCell>{hotel.cityName || 'N/A'}</TableCell>
                  <TableCell>{hotel.areaName || 'N/A'}</TableCell>
                  <TableCell>
                    {hotel.starRating ? (
                      <Chip label={`${hotel.starRating} Stars`} size="small" />
                    ) : (
                      'N/A'
                    )}
                  </TableCell>
                  <TableCell>
                    {hotel.distanceFromHaram ? `${hotel.distanceFromHaram} km` : 'N/A'}
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={hotel.isActive ? 'Active' : 'Inactive'}
                      color={hotel.isActive ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Button
                      size="small"
                      startIcon={<Visibility />}
                      onClick={() => navigate(`/hotels/${hotel.id}`)}
                    >
                      View
                    </Button>
                    <Button
                      size="small"
                      startIcon={<Edit />}
                      onClick={() => navigate(`/hotels/${hotel.id}/edit`)}
                      sx={{ ml: 1 }}
                    >
                      Edit
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default HotelsPage;
